import { render, staticRenderFns } from "./Row.vue?vue&type=template&id=71d8c9a6&scoped=true&"
import script from "./Row.vue?vue&type=script&lang=js&"
export * from "./Row.vue?vue&type=script&lang=js&"
import style0 from "./Row.vue?vue&type=style&index=0&id=71d8c9a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d8c9a6",
  null
  
)

export default component.exports